function StepperProgressBarMobile() {
    return <svg width="66" height="16" viewBox="0 0 66 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.57422 8L25.0742 8" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M31.0742 14L35.7409 8.16667L31.0742 2.33333" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M41.0742 8L64.5742 8" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
  </svg>;
}

export default StepperProgressBarMobile;